import { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../../msalConfig";

const FormLoginSSO = () => {
  const { instance, inProgress, accounts } = useMsal();

  useEffect(() => {    
    if (inProgress === "none" && accounts.length === 0) {
      instance.loginRedirect(loginRequest);
    }
  }, [instance, inProgress, accounts]);

  return null;
};

export default FormLoginSSO;